/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Card, CardContent, Typography, Stack } from '@mui/material';
import { getOutstandingDays } from '@/utils/constants';
import { useObjectContext } from '@/hooks/useObjectContext';
import { usePipelineContext } from '@/context/pipelineContext';
import { safelyParseDate } from '@/utils/date';

export const OutstandingDaysCounter = () => {
	const { dealRow } = useObjectContext();
	const { firebasePipelines } = usePipelineContext();

	const formattedDate = dealRow?.effectiveDate
		? Math.floor(safelyParseDate(dealRow.effectiveDate)?.getTime?.() ?? 1 / 1000)
		: null;

	const stageData = useMemo(() => {
		if (!firebasePipelines || !dealRow?.dealStage) return null;
		const debtorPipeline = firebasePipelines.find((p) => p.pipelineLabel === 'debtors');
		const foundStage = debtorPipeline?.stages?.find((s) => s.stageId === dealRow.dealStage);
		return foundStage ?? null;
	}, [firebasePipelines, dealRow?.dealStage]);

	const outstandingDays = useMemo(() => {
		if (!dealRow?.effectiveDate || !formattedDate || stageData?.order !== 0) return '-';
		const days = getOutstandingDays(formattedDate);
		if (days === 1) return '1 day';
		return `${days} days`;
	}, [dealRow?.effectiveDate, stageData]);

	return (
		<Card variant='outlined' sx={{ minWidth: 120 }}>
			<CardContent>
				<Stack spacing={1} direction={'column'}>
					<Typography variant='subtitle2' color='text.secondary'>
						Days Outstanding
					</Typography>
					<Typography variant='h4' sx={{ fontWeight: 'bold' }}>
						{outstandingDays}
					</Typography>
				</Stack>
			</CardContent>
		</Card>
	);
};
